export const disableAutoBookScroll = () => {
  const autobookListBody = document.getElementById('autobookListBody');
  const autobookTable = document.getElementById('autobookTable');

  if (autobookListBody) autobookListBody.style.overflow = 'hidden';

  if (autobookTable) autobookTable.style.overflow = 'hidden';
};

export const enableAutoBookScroll = () => {
  const autobookListBody = document.getElementById('autobookListBody');
  const autobookTable = document.getElementById('autobookTable');

  if (autobookListBody) autobookListBody.style.overflow = 'auto';

  if (autobookTable) autobookTable.style.overflow = 'auto';
};
